<template> <!-- 休日コンポーネント(子) -->
  <div id="holidaywork">
    <p style="margin-bottom: 3px; width: 60px; text-align:center;">
      <span>{{ holidays[index] }}</span>
      <input type="hidden" :value="holiday" />
    </p>
  </div>
</template>

<script>
import moment from 'moment'
import ConstList from './../ConstList'
export default {
  name: 'HolidayWork',
  data () {
    return {
      holidays: [],
      deducts: []
    }
  },
  props: {
    monthDay: Array,
    start: Array,
    end: Array,
    rest: Array,
    attendance1: Array,
    index: Number
  },
  computed: {
    // 休日の自動計算
    holiday: function () {
      let list = this.holidays
      let day = this.monthDay;
      for (let i = 0; i < this.start.length; i++) {
        const sStr = this.start[i];
const eStr = this.end[i];

// 開始・終了どちらかが未入力なら null
if (!sStr || !eStr) {
  list.splice(i, 1, null);
  continue;
}

const sTime = moment.duration(sStr, 'HH:mm');
const eTime = moment.duration(eStr, 'HH:mm');
        const bTime = moment.duration(this.rest[i], 'HH:mm')
        const diff = eTime.clone().subtract(sTime).subtract(bTime)
        if (this.attendance1[i] === ConstList.HOLIDAY
          && (day[i].substring(day[i].lastIndexOf("(") + 1,day[i].lastIndexOf(")")) ==="日")
        ) {
          const hours = diff.hours() < 10 ? '0' + diff.hours() : diff.hours()
          const minutes = diff.minutes() < 10 ? '0' + diff.minutes() : diff.minutes()
          const time = hours + ':' + minutes
          if(time == "00:00") list.splice(i, 1, null)
          else                list.splice(i, 1, time)
          continue
        } else {
          list.splice(i, 1, null)
          continue
        }
    }return null
    }
  },
  watch: {
    holidays: {
      deep: true,
      handler(newVal) {
        this.$emit('updateHolidayWork', {
          index: this.index,
          value: newVal[this.index]
        });
      }
    }
  },
  methods: {
    updateDeduct(dailyDeduct) {
      console.log('updateDeduct called with:', dailyDeduct);
      this.deducts = dailyDeduct;
    }
}
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
</style>
